import React from 'react';
export const CFIconFacebook = {
    alias: 'facebook',
    defaultTitle: 'Facebook',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M24 12c0-6.63-5.37-12-12-12S0 5.37 0 12c0 5.99 4.39 10.95 10.12 11.85v-8.39H7.07v-3.47h3.05V9.35c0-3.01 1.79-4.67 4.53-4.67 1.31 0 2.69.23 2.69.23v2.95h-1.51c-1.49 0-1.96.93-1.96 1.87v2.25h3.33l-.53 3.47h-2.8v8.39c5.74-.9 10.12-5.86 10.12-11.85L24 12Z' }))),
};
